/**
 * Lo que se acaba de hacer, dicho un momento.
 *
 * A task now ends where it began (`lib/volver.ts`), and the screen it went on to used to be what
 * said it was done: a purchase landed on the list of purchases, a product on its own page. Back on
 * the home screen, or wherever the task was opened from, nothing would say it, so the task says it
 * here, and `ui/Hecho.tsx` shows it for a moment over whatever screen it went back to.
 */

type Oyente = (texto: string) => void;

const oyentes = new Set<Oyente>();

/** Said once, as the task leaves: what was done, in a few words. */
export function anunciar(texto: string): void {
  for (const oyente of oyentes) oyente(texto);
}

export function escucharHecho(oyente: Oyente): () => void {
  oyentes.add(oyente);
  return () => {
    oyentes.delete(oyente);
  };
}
